<script lang="ts">
    import WishlistButton from "@apps/iloom_customization/components/WishlistButton.svelte";
    import cn from "classnames";

    let className = "";
    export { className as class };
    export let inWishlist: boolean | undefined;
    export let handleDelete: () => void;
    export let handleAdd: () => void;
</script>

<WishlistButton
    class={cn("gw-media-wishlist-btn", className)}
    {inWishlist}
    {handleAdd}
    {handleDelete}
/>

<style lang="postcss">
    :global(.gw-btn.gw-media-wishlist-btn) {
        position: absolute;
        bottom: 20px;
        right: 20px;
        width: 48px;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #ffffffcc;
        border-radius: 50%;
    }
    @media all and (max-width: 600px) {
        :global(.gw-btn.gw-media-wishlist-btn) {
            transform: scale(0.6);
            transform-origin: bottom right;
        }
    }
</style>
